import { setCountry, setDuration, setSeedKeyword, setWebSource } from "app/actions/keywordGeneratorToolActions";
import { KeywordGeneratorToolResultsTable } from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/google-keyword-generator/KeywordGeneratorToolResultsTable";
import React, { type JSX } from "react";
import { EKWGeneratorTableTabs } from "app/common/keyword-research/keyword-generator/types";
import { useSelector } from "react-redux";
import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { tableActionsCreator } from "app/actions/tableActions";
import { TABLE_SELECTION_PROPERTY, TABLE_SELECTION_KEY } from "app/common/keyword-research/keyword-generator/constants";

export const KeywordGeneratorToolInlinePage = (): JSX.Element => {
    const { params } = useCurrentStateAndParams();
    const dispatch = useDispatch();
    const tableAction = tableActionsCreator(TABLE_SELECTION_KEY, TABLE_SELECTION_PROPERTY);
    const { country, duration, seedKeyword, webSource } = useSelector((store) => store.keywordGeneratorTool);
    const { country: initialCountry, duration: initialDuration, keyword, webSource: initialWebSource, tab } = params;

    React.useEffect(() => {
        if (country !== initialCountry) {
            dispatch(setCountry(initialCountry));
        }
        if (duration !== initialDuration) {
            dispatch(setDuration(initialDuration));
        }
        if (webSource !== initialWebSource) {
            dispatch(setWebSource(initialWebSource));
        }
        if (seedKeyword !== keyword) {
            dispatch(tableAction.clearAllSelectedRows());
            dispatch(setSeedKeyword(keyword));
        }
    }, [
        country,
        initialCountry,
        setCountry,
        duration,
        initialDuration,
        setDuration,
        webSource,
        initialWebSource,
        setWebSource,
        seedKeyword,
        keyword,
        setSeedKeyword,
    ]);

    const handleTabSelect = (tab: string) => {
        proNavigator.updateQueryParams({ tab }, { reload: false });
    };

    return (
        <>
            {country &&
            country === initialCountry &&
            duration &&
            duration === initialDuration &&
            webSource &&
            webSource === initialWebSource &&
            seedKeyword &&
            seedKeyword === keyword ? (
                <KeywordGeneratorToolResultsTable
                    params={params}
                    notify={true}
                    selectedTab={EKWGeneratorTableTabs[tab] ?? EKWGeneratorTableTabs.phraseMatch}
                    onTabSelect={handleTabSelect}
                />
            ) : null}
        </>
    );
};
